import React, { useState } from "react";
import { Link} from "gatsby"
import { GatsbyImage, getImage, StaticImage } from "gatsby-plugin-image"

function TaalreisMenu() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleMouseEnter = () => {
    setIsMenuOpen(true);
  };

  const handleMouseLeave = () => {
    setIsMenuOpen(false);
  };

  return (
    <div
      className="relative hidden lg:inline-block text-left group"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div
        className="cursor-pointer font-inter justify-center rounded-md px-2 py-2 font-semibold hover:bg-opacity-30 relative hover:no-underline hover:after:content-[''] hover:after:absolute hover:after:left-3 hover:after:w-32 hover:after:bottom-[-2px] hover:after:h-[2px] hover:after:bg-current transition-all duration-300"
        onMouseEnter={handleMouseEnter}
      >
        Surf &amp; Taalreizen
      </div>
      {isMenuOpen && (
        <div
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          className="absolute font-inter right-0 -mt-1 w-[26rem] origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none mt-1"
        >
          <div className="grid grid-cols-2 gap-2 p-2 text-sm font-semibold">

          <div className="rounded-md p-2 hover:bg-stone-100 mr-2 flex items-center">
  <Link to="/surfvakanties/surf-en-taalreizen" className="flex pt-2">
    <img className="block w-6 h-6 mr-2" src="https://wp.surfawhile.com/wp-content/uploads/2023/05/worldwide.png" />
    Alle Taalreizen
  </Link>
</div>

<div className="rounded-md p-2 hover:bg-stone-100 mr-2 flex items-center">
  <Link to="/surfvakanties/surf-en-taalreizen/spaans-leren-en-surfen" className="flex pt-2">
  <img className="block w-6 h-6 mr-2" src="https://wp.surfawhile.com/wp-content/uploads/2023/05/spain.png" />
    Spaans &amp; Surfen 
    {/* <span className="bg-stone-400 text-white font-semibold p-1 rounded-lg ml-1 -mt-1"> Populair</span> */}
  </Link>
</div>

<div className="rounded-md p-2 hover:bg-stone-100 mr-2 flex items-center">
  <Link to="/surfvakanties/surf-en-taalreizen/engels-leren-en-surfen" className="flex pt-2">
    <img className="block w-6 h-6 mr-2" src="https://wp.surfawhile.com/wp-content/uploads/2023/11/united-kingdom.png" />
    Engels  &amp; Surfen
  </Link>
</div>

<div className="rounded-md p-2 hover:bg-stone-100 mr-2 flex items-center">
  <Link to="/surfvakanties/surf-en-taalreizen/frans-leren-en-surfen" className="flex pt-2">
    <img className="block w-6 h-6 mr-2" src="https://wp.surfawhile.com/wp-content/uploads/2023/05/france.png" />
    Frans &amp; Surfen
  </Link>
</div>

 
          </div>
        </div>
      )}
    </div>
  );
}

export default TaalreisMenu;
